import { utilsModule } from "../utils-module";

declare var window: Window & any

utilsModule.factory('fileUtilsService',['$q','$http','$window',function($q,$http,$window){

    return {
        /**
         * Abre um arquivo utilizando o visualizador padrão definido no dispositivo
         * Em ambiente cordova, depende do plugin cordova-plugin-fileopener
         * Ainda não suporta ambiente ionic
         * @param {string}  fileUrl a url do arquivo. Pode ser local ou via http
         * @param {string}  fileMIMEType tipo do arquivo
         * @param {string}  extension extensão do arquivo
         * @returns {promise}
         */
        openFile : function(fileUrl:string,fileMIMEType:string,extension:string){
            var d = $q.defer();

            if (typeof window.cordova !== "undefined"){
                // APLICAÇÃO CORDOVA (ANDROID)
                //-----------------------------
                function onSuccess(data) {
                    if (!data.canBeOpen){
                        d.reject({data:data, message:"Você não possui um leitor de "+data.extension+" instalado no dispositivo. Realize a instalação de um e tente novamente!"})
                        return;
                    }

                    window.cordova.plugins.FileOpener.openFile(fileUrl, 
                    function(){
                        d.resolve();
                    },function(error){
                        d.reject({message:"Ocorreu um erro", error:error});
                    });

                }

                function onError(error) {
                    d.reject({message:"Ocorreu um erro", error:error});
                }


                if(fileUrl.indexOf("http") == 0){
                    this.downloadFile(fileUrl,window.cordova.file.dataDirectory,`downloaded.${extension}`).then(()=>{
                        console.log("Arquivo baixado! Abrindo...");
                        var localFileName = `${window.cordova.file.dataDirectory}/downloaded.${extension}`;
                        open(localFileName,fileMIMEType);
                    })
                }else{
                    open(fileUrl,fileMIMEType);
                }


                

               function open(fileUrl,fileMIMEType){
                   window.cordova.plugins.fileOpener2.showOpenWithDialog(
                        fileUrl, // You can also use a Cordova-style file uri: cdvfile://192.168.1.106/persistent/Download/starwars.pdf
                        fileMIMEType, 
                        { 
                            error : onError,
                            success : onSuccess
                        }
                    );
               }
            }else{
                // APLICAÇÃO ELECTRON (WINDOWS E LINUX)
                //-------------------------------------
                d.resolve();
            }

            return d.promise;
        },


        /**
         * Abre um arquivo PDF 
         * Em ambiente cordova, utilizando o visualizador padrão definido no dispositivo (metodo openFile)
         * Em ambiente electron, utiliza o módulo electron-pdf-window
         * @param {string}  fileUrl a url do arquivo. Pode ser local ou via http
         * @returns {promise}
         */
        openPdf : function(pdfUrl){        
            function isElectron() {
                return process && process.versions && ((<any>process.versions).electron !== undefined);
            }

            if (typeof window.cordova !== "undefined"){
                // APLICAÇÃO CORDOVA (ANDROID)
                //-----------------------------
                return this.openFile(pdfUrl,'application/pdf','pdf');
            }else if(isElectron()){
                // comentado devido à remoção do electron, jonathan 2019-10-11 13:18:47
                // APLICAÇÃO ELECTRON (WINDOWS E LINUX)
                //-------------------------------------
                // var d = $q.defer();
                // const { BrowserWindow } = require('electron').remote
                // const PDFWindow = require('electron-pdf-window')

                // const win = new BrowserWindow({ width: 800, height: 600 })

                // PDFWindow.addSupport(win)

                // win.loadURL(pdfUrl);
                // win.setMenu(null);
                // d.resolve();
            }else{
                // APLICAÇÃO WEB
                //-------------------------------------
                var d = $q.defer();
                window.open(pdfUrl,'_blank');
                return d.resolve();
            }
            return d.promise;
        },


        /**
         * Realiza o download de um arquivo a partir de uma URL e salva o mesmo em um diretorio 
         * funciona para aplicação cordova e ionic
         * Testado com arquivo pdf, API do loopback
         * Ainda não testado com outros tipos de arquivo
         * 
         * Em ambiente cordova, depende do plugin cordova-plugin-file
         * 
         * @param {string} url a url do arquivo a ser baixado
         * @param {string} folderpath o diretorio onde o arquivo será salvo. No ambiente cordova,
         *                            se omitido utiliza a raiz do armazenamento externo
         * @param {string} fiename o nome com que o arquivo será salvo
         * @returns {promise}
         */
        downloadFile : function(url,folderpath,filename){
            var d = $q.defer();
            $http.get(url, {responseType: 'arraybuffer'})
            .then((result)=>{
                if (typeof  window.cordova !== "undefined"){
                    // APLICAÇÃO CORDOVA (ANDROID)
                    //-----------------------------
                    var DataBlob = new Blob([result.data]);
                    if(!folderpath){
                        folderpath = window.cordova.file.externalRootDirectory;
                    }

                    window.resolveLocalFileSystemURL(folderpath, function(dir) {
                        //"Access to the directory granted succesfully"
                        dir.getFile(filename, {create:true}, function(file) {
                            //"File created succesfully."
                            file.createWriter(function(fileWriter) {
                                //"Writing content to file"
                                fileWriter.onwrite = successCallback;
                                fileWriter.onerror = failCallback;
                                fileWriter.write(DataBlob);
                            }, failCallback);
                        });
                    });
                }else{
                    // APLICAÇÃO ELECTRON (WINDOWS E LINUX)
                    //-------------------------------------
                    try{
                        var fs = require('fs');
                        var data =  new Buffer(result.data);
                        fs.writeFileSync('/home/william/Downloads/'+filename,data,'binary')
                        window.successCallback();
                    }catch(error){
                        window.failCallback();
                    }
                }

                function successCallback(data){
                    d.resolve(data);
                }

                function failCallback(err){
                    d.reject(err);
                }
            })

            return d.promise;            
        }
    }
}]) 
